"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PillButton = void 0;
const styled_1 = __importDefault(require("@emotion/styled"));
const Button_1 = require("./Button");
const constants_1 = require("./constants");
const loading_spinner_secondary_svg_1 = __importDefault(require("./loading-spinner-secondary.svg"));
const loading_spinner_svg_1 = __importDefault(require("./loading-spinner.svg"));
exports.PillButton = (0, styled_1.default)(Button_1.Button) `
	border-radius: 20px;
	.merlin-button__loader {
		background-image: url(${(props) => props.buttonType === constants_1.PresetThemes.ThemeV5Neutral ? loading_spinner_secondary_svg_1.default : loading_spinner_svg_1.default});
		filter: none;
	:after {
		border-radius: 20px;
	}
`;
//# sourceMappingURL=PillButton.js.map